import axios from "axios"
import axiosInstance from "../helpers/axiosInstance"

let tokenCache = null
let tokenExpiry = 0
export const __resetTokenCache = () => {
  tokenCache = null
  tokenExpiry = 0
}

const TOKEN_BUFFER_MS = 60 * 1000
const DEFAULT_EXPIRES_IN_SECONDS = 30 * 60 // 30-minute safety net if platform omits expires_in

export const fetchNaturaSftpMonitorToken = async () => {
  const now = Date.now()
  if (tokenCache && now < tokenExpiry - TOKEN_BUFFER_MS) {
    return { token: tokenCache }
  }
  const { data } = await axiosInstance.post(
    `${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-sftp-monitor/token`
  )
  if (!data?.token) {
    throw new Error('natura-sftp-monitor token response missing "token" field')
  }
  const expiresInSeconds = data.expires_in > 0 ? data.expires_in : DEFAULT_EXPIRES_IN_SECONDS
  tokenCache = data.token
  tokenExpiry = now + expiresInSeconds * 1000
  return { token: tokenCache, expires_in: data.expires_in }
}

// uploadIdoc targets natura-sftp-monitor (different host, different JWT), not platform.
// Use raw axios so axiosInstance's platform-JWT interceptors don't fire.
export const uploadIdoc = async (file, token) => {
  const baseUrl = process.env.REACT_APP_NATURA_SFTP_MONITOR_URL
  if (!baseUrl) throw new Error("REACT_APP_NATURA_SFTP_MONITOR_URL is not set")
  const form = new FormData()
  form.append("file", file)

  const { data } = await axios.post(`${baseUrl}/wms/manual_orders`, form, {
    headers: {
      Authorization: `Bearer ${token}`,
      // Content-Type is auto-set by axios for FormData (includes the multipart boundary).
    },
  })
  return data
}
